import { dataCustomStat } from './dataCustomStat';

export const dataCustomStats = {
  type: 'array',
  items: dataCustomStat,
};
